import { useMemo } from 'react';
import { STATUS } from '@/utils/static/kyc';

export const useEntityStatus = (entity) => {
  return useMemo(() => {
    if (!entity?.status) {
      return {
        isRejected: false,
        isQuestionRejected: false,
        isInProcess: false,
        isInReview: false,
        isApproved: false
      };
    }

    const status = entity.status;

    return {
      isRejected: status === STATUS.REJECTED,
      isQuestionRejected: status === STATUS.QUESTION_UNACCEPTED,
      isInProcess: status === STATUS.NEW || status === STATUS.DRAFT,
      isInReview: status === STATUS.PROCESSING, 
      isApproved: status === STATUS.PASSED
    };
  }, [entity?.status]);
};

